import AppsFlyer from '~/assets/ext-link-appsflyer.svg'
import DataAI from '~/assets/ext-link-data.ai.svg'
import Facebook from '~/assets/ext-link-facebook.svg'
import Firebase from '~/assets/ext-link-firebase.svg'
import Gcp from '~/assets/ext-link-gcp.svg'
import LookerStudio from '~/assets/ext-link-looker_studio.svg'
import TikTok from '~/assets/ext-link-tiktok.svg'

export const LINKS: Record<string, string> = {
  appsflyer: AppsFlyer,
  dataai: DataAI,
  facebook: Facebook,
  firebase: Firebase,
  gcp: Gcp,
  lookerstudio: LookerStudio,
  tiktok: TikTok,
}
